<template>
  <v-menu
    ref="pickerMenu"
    v-model="pickerMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        fab
        color="#2722a6"
        v-b-tooltip.hover
        title="Click to open Calendar"
        v-bind="attrs"
        v-on="on"
        @click="pickerMenu = true"
      >
        <v-icon large color="white">mdi-calendar</v-icon>
      </v-btn>
    </template>
    <v-date-picker
      @change="updateCalendarDate"
      v-model="calendarValue"
      no-title
      color="#2722a6"
    />
  </v-menu>
</template>

<script>
export default {
  name: "FabButtonCalendarPicker",
  data() {
    return {
      pickerMenu: false,
      calendarValue: "",
    };
  },
  methods: {
    updateCalendarDate() {
      this.pickerMenu = false;
      this.gotoDate(this.calendarValue);
    },
    gotoDate(calendarValue) {
      this.$emit("calendar-date-selected", calendarValue);
    },
  },
};
</script>

<style scoped></style>
